import { Alert, AlertProps } from "@mui/material";
import { styled } from "@mui/material/styles";

export const CustomAlert = styled((props: AlertProps) => (
    <Alert {...props} />
))(({ theme, severity, variant }) => ({
    marginTop: theme.spacing(3),
    border: 0,
    scrollMargin: "200px",
    padding: `${theme.spacing(0)} ${theme.spacing(3)}`,
    color: theme.palette.text.primary,

    ...(variant === "transparent" && {
        backgroundColor: "transparent",
        borderLeft: "none"
    }),

    ...(severity && {
        backgroundColor: theme.palette[severity].light,
        borderLeft: `${theme.palette[severity].main} 4px solid`,
    }),
}));
